module.exports = __webpack_public_path__ + "media/images/header-back-771b000bfd1f3a2523d5823217b60fd3.jpg";